<template>
    <nav role="navigation" aria-label="Pagination Navigation">
        <ul class="v-pagination theme--dark">
            <li>
                <router-link :to="pageLink(value - 1)" class="v-pagination__item" event=""
                             @click.native.prevent="changePage(value - 1)" v-if="value > 1">
                    <v-icon>{{ mdiChevronLeft }}</v-icon>
                </router-link>
                <button aria-label="Previous page"
                        class="v-pagination__navigation v-pagination__navigation--disabled" v-else>
                    <v-icon>{{ mdiChevronLeft }}</v-icon>
                </button>
            </li>

            <li>
                <router-link :to="pageLink(1)" :class="{active: value === 1}" event=""
                             class="v-pagination__item" @click.native.prevent="changePage(1)">1
                </router-link>
            </li>

            <li v-if="length > showingItemsCount && value >= (showingItemsCount - 1)"><span class="v-pagination__more">...</span></li>

            <li v-if="length <= showingItemsCount">
                <router-link :to="pageLink(index + 1)" :class="{active: (index + 1) === value}" event=""
                             class="v-pagination__item" @click.native.prevent="changePage(index + 1)"
                             v-for="index in Math.max(length - 2, 0)" :key="index">
                    {{ index + 1 }}
                </router-link>
            </li>
            <li v-else-if="length > showingItemsCount && value < (showingItemsCount - 1)">
                <router-link :to="pageLink(index + 1)" :class="{active: (index + 1) === value}" event=""
                             class="v-pagination__item" @click.native.prevent="changePage(index + 1)"
                             v-for="index in Math.max(showingItemsCount - 2, 0)" :key="index">
                    {{ index + 1  }}
                </router-link>
            </li>
            <li v-else-if="length > showingItemsCount && value > (length - showingItemsCount + 2)">
                <router-link :to="pageLink(index + 1)" :class="{active: (index +  length - showingItemsCount + 1) === value}" event=""
                             class="v-pagination__item" @click.native.prevent="changePage((index +  length - showingItemsCount + 1))"
                             v-for="index in Math.max(showingItemsCount - 2, 0)" :key="index">
                    {{ index +  length - showingItemsCount + 1  }}
                </router-link>
            </li>
            <li v-else>
                <router-link :to="pageLink(index + 1)" :class="{active: index +  Math.min(value - showingItemsCount / 2) === value}"
                             class="v-pagination__item" @click.native.prevent="changePage(index +  Math.min(value - showingItemsCount / 2))" event=""
                             v-for="index in Math.max(showingItemsCount - 2, 0)" :key="index">
                    {{ index +  Math.min(value - showingItemsCount / 2)  }}
                </router-link>
            </li>

            <li v-if="length > showingItemsCount && value <= length - showingItemsCount + 2"><span class="v-pagination__more">...</span></li>

            <li v-if="length > 1">
                <router-link :to="pageLink(length)" :class="{active: value === length}" event=""
                             class="v-pagination__item" @click.native.prevent="changePage(length)">{{ length }}
                </router-link>
            </li>

            <li>
                <router-link :to="pageLink(value + 1)" class="v-pagination__item" event=""
                             @click.native.prevent="changePage(value + 1)" v-if="value < length">
                    <v-icon>{{ mdiChevronRight }}</v-icon>
                </router-link>
                <button aria-label="Next page"
                        class="v-pagination__navigation v-pagination__navigation--disabled" v-else>
                    <v-icon>{{ mdiChevronRight }}</v-icon>
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
import appConfig from "../../config/app";
import {mdiChevronLeft, mdiChevronRight} from '@mdi/js';

export default {
    name: "QueryStringPaginator",

    props: ['value', 'length', 'linksCount'],

    data: function () {
        return {
            showingItemsCount: this.linksCount || 10,
            mdiChevronLeft: mdiChevronLeft,
            mdiChevronRight: mdiChevronRight,
        };
    },

    metaInfo() {
        let metaData = {};

        let links = [];

        if(this.value > 1){
            let query = Object.assign({}, this.$route.query);

            if (this.value === 2){
                delete query.page;
            }else {
                query.page = (this.value - 1).toString();
            }

            let prevRoute = this.$router.resolve({
                query: query,
            });

            links.push({
                rel: 'prev',
                href: `${appConfig.appUrl}${decodeURIComponent(prevRoute.resolved.fullPath)}`,
                vmid: 'prev',
            });
        }

        if(this.value < this.length){
            let query = Object.assign({}, this.$route.query);
            query.page = (this.value + 1).toString();

            let nextRoute = this.$router.resolve({
                query: query,
            });

            links.push({
                rel: 'next',
                href: `${appConfig.appUrl}${decodeURIComponent(nextRoute.resolved.fullPath)}`,
                vmid: 'next',
            });
        }

        links.push({
            rel: 'canonical',
            href: `${appConfig.appUrl}${decodeURIComponent(this.$route.fullPath)}`,
            vmid: 'canonical',
        });

        metaData.link = links;

        return metaData;
    },

    methods: {
        pageLink(page) {
            let query = Object.assign({}, this.$route.query);
            if (page > 1){
                query.page = page;
            }else {
                delete query.page
            }

            let linkRoute = this.$router.resolve({
                query: query,
            });

            return decodeURIComponent(linkRoute.resolved.fullPath)
        },

        changePage(page) {
                this.$emit('input', page);
                this.$emit('change', page);
        }
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/QueryStringPaginator"
</style>